export default __webpack_public_path__ + "static/media/bg-nav-dna-profile.13d5d4f5.jpg";